'use strict';

module.exports = {

    token: null,

    getUrl() {
        return Odigeo.Settings.getProperty('membershipRenewalServiceFormatter')('getRenewalOffer');
    },

    getMethod: Odigeo._.constant('GET'),

};
